<div class="year-box">
  <div class="mdlz-yrp-container">
    <div class="mdlz-yrp-picker-box">
      <span class="timeframedate" [ngClass]="{ 'qtr-placeholder': selectedQtrs.length < 2, 'qtr-text': selectedQtrs.length > 1 }">
        {{ selectedQtrs.length > 1 ? displayTimeFrameDate : 'Select Start and End Quarters' }}
      </span>
      <img
        src="../../../../assets/images/calendar_today-mdlz-primary.svg"
        alt="Calendar Icon"
        class="mdlz-yrp-calendar-icon cursor-pointer"
        width="15px"
        height="18px"
        (click)="showCalendar = !showCalendar"
      />
    </div>
  </div>
  <div *ngIf="showCalendar" class="mdlz-yrp-options-container">
    <div class="inline-flex gap-8 pl-4 pr-2 py-2.5">
      <div class="cell-header">Start</div>
      <div class="cell-header">End</div>
    </div>
    <div class="inline-flex h-48 overflow-y-auto w-36 gap-1">
      <div class="mdlz-yrp-options-column">
        <div
          class="mdlz-yrp-options-cell cursor-pointer"
          *ngFor="let qtrObj of qtrYearsList; index as i"
          [ngClass]="{
            'mdlz-yrp-options-selected': qtrObj == this.selectedStartQtr,
            'mdlz-yrp-options-disabled': this.selectedEndQtrIndex && i > this.selectedEndQtrIndex
          }"
          (click)="selectYear('selectedStartQtr', qtrObj)"
        >
          {{ qtrObj }}
        </div>
      </div>
      <div class="mdlz-yrp-options-column">
        <div
          class="mdlz-yrp-options-cell cursor-pointer"
          *ngFor="let qtrObj of qtrYearsList; index as j"
          [ngClass]="{
            'mdlz-yrp-options-selected': qtrObj == this.selectedEndQtr,
            'mdlz-yrp-options-disabled': j < this.selectedStartQtrIndex
          }"
          (click)="selectYear('selectedEndQtr', qtrObj)"
        >
          {{ qtrObj }}
        </div>
      </div>
    </div>
    <div class="footer-btn"><a class="cursor-pointer" (click)="clearSelection()"> Clear </a> <a class="cursor-pointer" (click)="applySelectedSet()"> Apply </a></div>
  </div>
</div>
